import {playAudio as playAuthorizedAudio} from '../pages/ArabicLessons/utils/audioUtils';
/**
 * Утилиты для работы с аудио
 */

export interface AudioOptions {
  volume?: number;
  loop?: boolean;
  autoplay?: boolean;
}

/**
 * Воспроизведение аудио файла
 * @param url URL аудио файла
 * @param token Токен авторизации
 * @param options Опции воспроизведения
 */
export const playAudio = (url:string,token:string|null=null,options:AudioOptions={}):Promise<void> => playAuthorizedAudio(url,token,options);

/**
 * Создание аудио элемента с настройками
 * @param url URL аудио файла
 * @param options Опции аудио
 */
export const createAudioElement = (
  url: string,
  options: AudioOptions = {}
): HTMLAudioElement => {
  const audio = new Audio(url);

  if (options.volume !== undefined) {
    audio.volume = options.volume;
  }
  if (options.loop !== undefined) {
    audio.loop = options.loop;
  }
  if (options.autoplay !== undefined) {
    audio.autoplay = options.autoplay;
  }

  return audio;
};

/**
 * Остановка всех воспроизводящихся аудио элементов
 */
export const stopAllAudio = (): void => {
  const audioElements = document.querySelectorAll('audio');
  audioElements.forEach(audio => {
    if (!audio.paused) {
      audio.pause();
      audio.currentTime = 0;
    }
  });
};

/**
 * Получение текущего времени воспроизведения
 * @param audioElement Элемент аудио
 */
export const getCurrentTime = (audioElement: HTMLAudioElement): number => {
  return audioElement.currentTime;
};

/**
 * Установка времени воспроизведения
 * @param audioElement Элемент аудио
 * @param time Время в секундах
 */
export const setCurrentTime = (audioElement: HTMLAudioElement, time: number): void => {
  audioElement.currentTime = time;
};

/**
 * Проверка, воспроизводится ли аудио
 * @param audioElement Элемент аудио
 */
export const isPlaying = (audioElement: HTMLAudioElement): boolean => {
  return !audioElement.paused && !audioElement.ended && audioElement.readyState > 2;
};

/**
 * Пауза аудио
 * @param audioElement Элемент аудио
 */
export const pauseAudio = (audioElement: HTMLAudioElement): void => {
  audioElement.pause();
};

/**
 * Возобновление воспроизведения аудио
 * @param audioElement Элемент аудио
 */
export const resumeAudio = (audioElement: HTMLAudioElement): Promise<void> => {
  return audioElement.play();
};

/**
 * Остановка аудио (пауза + сброс времени)
 * @param audioElement Элемент аудио
 */
export const stopAudio = (audioElement: HTMLAudioElement): void => {
  audioElement.pause();
  audioElement.currentTime = 0;
};
